import Idtroc from "./components/Idtroc.vue";
import Cgu from "./components/CGU.vue";
import FAQ from "./components/FAQ.vue";
import MentionsLegales from "./components/MentionsLegales.vue";
import Confidentialite from "./components/Confidentialite.vue";
import PageNotFound from "./components/PageNotFound.vue";

const routes = [
  {
    path: "/",
    component: Idtroc,
    meta: {
      title: "IDTROC - articles d'occasion",
      metaTags: [
        {
          name: "description",
          content:
            "Vendez et achetez vos vêtements jeux jouets et livres pour enfant d'occasion en magasin."
        },
        {
          property: "og:description",
          content:
            "Vendez et achetez vos vêtements jeux jouets et livres pour enfant d'occasion en magasin."
        }
      ]
    }
  },
  {
    path: "/cgu",
    component: Cgu,
    meta: {
      title: "IDTROC - conditions d'utilisation",
      metaTags: [
        {
          name: "description",
          content:
            "conditions d'utilisation de l'application IDTROC de dépot vente en magasin."
        },
        {
          property: "og:description",
          content:
            "conditions d'utilisation de l'application IDTROC de dépot vente en magasin."
        }
      ]
    }
  },
  {
    path: "/mentions-legales",
    component: MentionsLegales,
    meta: {
      title: "IDTROC - mentions légales",
      metaTags: [
        {
          name: "description",
          content:
            "mentions légales de l'application IDTROC de dépot vente en magasin."
        },
        {
          property: "og:description",
          content:
            "mentions légales de l'application IDTROC de dépot vente en magasin."
        }
      ]
    }
  },
  {
    path: "/politique-confidentialite",
    component: Confidentialite,
    meta: {
      title: "IDTROC - politique de confidentialité",
      metaTags: [
        {
          name: "description",
          content:
            "politique de confidentialité de l'application IDTROC de dépot vente en magasin."
        },
        {
          property: "og:description",
          content:
            "politique de confidentialité de l'application IDTROC de dépot vente en magasin."
        }
      ]
    }
  },
  {
    path: "/faq",
    component: FAQ,
    meta: {
      title: "IDTROC - foire aux questions",
      metaTags: [
        {
          name: "description",
          content:
            "réponses aux questions courantes à propos des dépots vente en magasin IDTROC."
        },
        {
          property: "og:description",
          content:
            "réponses aux questions courantes à propos des dépots vente en magasin IDTROC."
        }
      ]
    }
  },
  {
    path: "*",
    component: PageNotFound,
    meta: {
      title: "IDTROC - page introuvable",
      metaTags: [
        {
          name: "description",
          content: "l'url n'existe pas, page 404."
        },
        {
          property: "og:description",
          content: "l'url n'existe pas, page 404."
        }
      ]
    }
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js